module.exports = __webpack_public_path__ + "static/how-to-pay-2-1c04729a38597745db87f143e1c226ae.png";